import { faArrowRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, JoonUIColor, Modal, Typography } from "@joonapp/web-shared"

import usePrivacyPolicyUpdateModalStore from "./usePrivacyPolicyUpdateModalStore"
import { QUERY_KEYS } from "../../../constants"
import { signAgreement } from "../../../networking/agreementLinks/api"
import { usePrivacyPolicyAgreementLinksQuery } from "../../../networking/agreementLinks/queries"
import { queryClient } from "../../../util/queryClient"

const PrivacyPolicyUpdateModal = () => {
  const { isOpen, onClose } = usePrivacyPolicyUpdateModalStore()
  const { data: privacyPolicyAgreementLinks, isLoading } =
    usePrivacyPolicyAgreementLinksQuery()

  const handleClose = () => {
    if (
      isLoading ||
      !privacyPolicyAgreementLinks ||
      privacyPolicyAgreementLinks.length < 1
    )
      return
    signAgreement(privacyPolicyAgreementLinks[0].id).then(() =>
      queryClient.invalidateQueries([QUERY_KEYS.PRIVACY_POLICY_AGREEMENT_LINKS])
    )
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} mandatory>
      <div
        className="flex flex-col gap-4 p-6"
        style={{ width: "min(400px, 95vw)" }}
      >
        <Typography variant="h4">
          We recently updated our Privacy Policy and Terms of Service
        </Typography>
        <div className="flex flex-col gap-2">
          <div className="flex flex-col">
            <Typography variant="bodySmall">
              Here are some of the highlights:
            </Typography>
            <Typography variant="bodySmall" className="ml-2">
              • We're introducing voice interaction for children using the Joon
              AI bot. This new feature allows kids to talk with their AI
              companion out loud instead of just typing.
            </Typography>
            <Typography variant="bodySmall" className="ml-2">
              • Our Privacy Policy now clarifies how voice data is handled:
              voice input is processed in real time but never stored. We do not
              keep recordings or transcripts.
            </Typography>
            <Typography variant="bodySmall">
              You can review the full documents below:
            </Typography>
          </div>
          <a
            className="flex flex-row items-center gap-2 justify-between"
            href="https://www.joonapp.io/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            <Typography
              variant="bodySmall"
              color={JoonUIColor.text.primaryAccent}
            >
              Privacy Policy
            </Typography>
            <FontAwesomeIcon
              icon={faArrowRight}
              fontSize={8}
              color={JoonUIColor.icon.accent}
            />
          </a>
          <a
            className="flex flex-row items-center gap-2 justify-between"
            href="https://www.joonapp.io/terms-of-service"
            target="_blank"
            rel="noreferrer"
          >
            <Typography
              variant="bodySmall"
              color={JoonUIColor.text.primaryAccent}
            >
              Terms of Service
            </Typography>
            <FontAwesomeIcon
              icon={faArrowRight}
              fontSize={8}
              color={JoonUIColor.icon.accent}
            />
          </a>
        </div>
        <Button
          onClick={handleClose}
          text="Okay!"
          fullWidth
          disabled={isLoading}
        />
      </div>
    </Modal>
  )
}

export default PrivacyPolicyUpdateModal
